export default "/static/empty/no-cases.png"